import { useState } from "react";
import PropTypes from "prop-types";
import { cn } from "@helpers/general";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import IconAdd from "../icons/svgs/add.svg";
import IconMinus from "../icons/svgs/minus.svg";
import IconArrow from "../icons/svgs/arrow-right.svg";
import { IconType } from "../../constants/IconType";
import "../../layouts/components.scss";

function Accordion(props) {
  const {
    title,
    subtitle,
    children,
    titleClassName = "typo-body font-bold",
    iconType = "",
    useParentGap = false,
  } = props;
  const [open, setOpen] = useState(props.isOpen || false);

  const toggleAccordion = () => {
    setOpen(!open);
  };

  const generateIcon = (isOpen) => {
    switch (iconType) {
      case IconType.ARROW:
        return isOpen ? (
          <IconArrow
            style={{ transform: "rotate(270deg)" }}
            width="8"
            height="17"
            fill="none"
            stroke="#000000"
          />
        ) : (
          <IconArrow
            style={{ transform: "rotate(90deg)" }}
            width="8"
            height="17"
            fill="none"
            stroke="#000000"
          />
        );
      default:
        return isOpen ? (
          <div className="al_accordion__close">
            <IconMinus width="30" stroke="#000000" />
          </div>
        ) : (
          <div className="al_accordion__open">
            <IconAdd width="30" fill="#000000" />
          </div>
        );
    }
  };

  return (
    <div
      className={cn("flex flex-col", {
        al_accordion_open: open,
        "mb-[20px]": open && !useParentGap,
      })}
    >
      <button
        className={cn(
          "flex items-center justify-between border-unset cursor-pointer",
          useParentGap
            ? open && "mb-[10px] desktop:mb-[15px]"
            : "mb-[15px] mobile:mb-[10px]"
        )}
        onClick={toggleAccordion}
        type="button"
      >
        <div className="flex flex-col items-start">
          <p className={cn(titleClassName, "font-bold", { underline: open })}>{title}</p>
          {subtitle && <p className="typo-body mt-[5px]">{subtitle}</p>}
        </div>
        {generateIcon(open)}
      </button>
      {open && <div>{children}</div>}
    </div>
  );
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  titleClassName: PropTypes.string,
  iconType: PropTypes.string,
  useParentGap: PropTypes.bool,
};

export default withALErrorBoundary({
  name: "Accordion",
  priority: "P2",
})(Accordion);
